export default __webpack_public_path__ + "static/media/Ashwanth.a721d81a.jpg";